// Edit planner for GRANT / REVOKE / DENY (v2 Slice F2).
//
// PRD: Ralph/DdlStructuralEdit2/PRD.md § Slice F2.
//
// All three ops append a fresh statement after the source statement (DSE2-7:
// no coalescing by default). Per-engine support / rejection lives in the
// dialect synthesizer — `dialect.grant.ts`.

import { rangeFromOffsets } from '../../../sql-grammar/document/lineIndex';
import type { DdlEdit, PlannedByteEdit } from '../../types';

import { pickAppendInsertion } from './appendInsertion';
import type { DdlEditCtx } from './applyDdlEdit';
import { synthesizeDeny, synthesizeGrant, synthesizeRevoke } from './dialect.grant';

type GrantEdit = Extract<DdlEdit, { op: 'grant' | 'revoke' | 'deny' }>;

export function planGrantEdit(
  ctx: DdlEditCtx,
  edit: GrantEdit,
): readonly PlannedByteEdit[] {
  const synth = synthForGrant(ctx, edit);
  const { offset: insertAt, sep, trailSep } = pickAppendInsertion(
    ctx.source,
    ctx.statementInfo.range.endOffset,
  );
  return [{
    range: rangeFromOffsets(ctx.lineIdx, insertAt, insertAt),
    replacement: sep + synth + trailSep,
    rationale: edit.op,
  }];
}

function synthForGrant(ctx: DdlEditCtx, edit: GrantEdit): string {
  switch (edit.op) {
    case 'grant':
      return synthesizeGrant(ctx.engine, edit.grant);
    case 'revoke':
      return synthesizeRevoke(ctx.engine, edit.revoke);
    case 'deny':
      return synthesizeDeny(ctx.engine, edit.deny);
  }
}
